$(() => {
  $(".copy-right-block").each(function () {
    const contentText = jgwcjmPackage.copyRight.getContent();
    const icpNumber = jgwcjmPackage.copyRight.getIcpNumber();
    const policLinkHref = jgwcjmPackage.copyRight.getPublicCodeLink();
    const $t = $(this);
    $t.find(".content").text(
      "Copyright 2005-2025 技术架构：超级码科技股份   版权所有Inc. All Reserved."
    );
    // $t.find(".icp-link").text(icpNumber.number).attr("href", icpNumber.href);
    //
    // if (!icpNumber.publicCode) {
    //   $t.find('.polic-link').hide();
    // }
    // $t.find(".polic-link")
    //   // .attr("href", policLinkHref)
    //   .find("span")
    //   // .text(`浙公网安备${icpNumber.publicCode}号`);
    //   .text(`浙公网安备 33010602001041 号`);
  });
});
// Copyright 2005-2025 技术架构：超级码科技股份   版权所有Inc. All Reserved. 浙ICP备09106406号-9         浙公网安备 33010602001041号
